export const MONACO_DARK_THEME = 'vs-dark';
export const MONACO_LIGHT_THEME = 'vs';
